const ComplainHandlingComponent = () => {
  return (
    <>
      <h2>苦情対応ポリシー</h2>
      <div className="content-wrapper">
        <h3>企業ポリシー</h3>
        <p>
          私たちは、コンテンツの出演者および視聴者の人権を守ります。<br/><br/>
          私たちは、児童ポルノ（Child Sexual Abuse Material（CSAM)）、近親相姦、獣姦、同意のない性的行為、体の切断、人身売買、性売買、または虐待を促進または助長するようなコンテンツは取り扱いいたしません。<br/><br/>
          私たちは、18歳未満（未成年者）ならびに出演者の同意のないコンテンツは販売しません。
        </p>
        <h3>苦情ポリシー</h3>
        <p>
          私たちは、消費者、児童保護や人権保護団体（個人、法人および国内、海外を問わない）を含む第三者からコンテンツに対して弊社ポリシーに反する可能性があると指摘を受けたときは、速やかに調査を行います。調査の結果、ポリシーに反するコンテンツに該当すると弊社もしくは関連機関が判断した場合、直ちに対象コンテンツの削除を行います。<br/><br/>
          私たちは、コンテンツの出演者から出演の同意をしていない、もしくはコンテンツの頒布の同意をしていないと主張を受けたときは、該当のコンテンツは同意の状況を確認できるまで、閲覧、購入ができないように措置を講じます。なお、同意が確認できなかった場合、または、コンテンツの出演者が、適用される法律の下で同意が無効であることを証明できる場合、直ちにコンテンツを削除いたします。苦情連絡先は以下のとおりとなります。
        </p>

        <h3>お問い合わせ先</h3>
        <p>info.wasabi.fas@gmail.com</p>
      </div>
    </>
  );
};

export default ComplainHandlingComponent;
